import { MarketplaceApi } from '@deckee/api-app-main';
import apiConfiguration from '../../../backend/apiConfiguration';

const api = new MarketplaceApi(apiConfiguration);

export default api;
